import { Component, type ComponentClass, type FC, Fragment } from "react";
import StudentsTemplate from "../components/templates/StudentsTemplate/index";
import { WithRouterProps, withRouter } from "../helpers/RouterHelper";
import { StudentFilterInterface } from "../interfaces/FiltersInterface";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
  AuthenticateRouterProps,
} from "./enhanceAuthenticatedPage";

export interface StudentsPageProps
  extends WithRouterProps<AuthenticateRouterProps>,
    AuthenticatedPageProps,
    AuthenticatedPageCallbacks {}

interface PageInfoInterface {
  title: string;
}

const enhanceStudentsPage = (
  WrappedComponent: ComponentClass<any, any> | FC<any>,
  pageInfo: PageInfoInterface,
) => {
  class StudentsPage extends Component<
    StudentsPageProps,
    Record<string, never>
  > {
    get studentFilter() {
      return this.props.studentFilterContext.studentFilters.find(
        (studentFilter: StudentFilterInterface) => {
          return (
            !!this.props.currentSection.data &&
            studentFilter.sectionId === this.props.currentSection.data.id
          );
        },
      );
    }

    render() {
      if (
        !this.props.student.data ||
        this.props.student.data.id !== this.props.params.studentId ||
        !this.props.currentOperator ||
        !this.props.currentSection.data ||
        !this.props.operatorPrivileges.data
      ) {
        return null;
      }

      const title =
        pageInfo.title === "アナリティクス" && this.props.student.data
          ? `${this.props.student.data.fullName} アナリティクス`
          : pageInfo.title;

      return (
        <Fragment>
          <StudentsTemplate pageInfo={{ title }}>
            <WrappedComponent
              {...this.props}
              student={this.props.student.data}
            />
          </StudentsTemplate>
        </Fragment>
      );
    }
  }

  return withRouter<StudentsPageProps>(enhanceAuthenticatedPage(StudentsPage));
};

export default enhanceStudentsPage;
